import { useMemo } from 'react';

// Anchors a "now" function to the server's clock so client-side machines
// with skewed system time still see the correct countdowns.
// skew = clientNow - serverNow at hydration; serverTimeNow() = Date.now() - skew.
export function useServerTimeNow(serverNow: string): () => Date {
  const clockSkewMs = useMemo(
    () => Date.now() - new Date(serverNow).getTime(),
    [serverNow],
  );

  return useMemo(() => () => new Date(Date.now() - clockSkewMs), [clockSkewMs]);
}
